import { useMutation } from '@tanstack/react-query';
import { registerDevice, deleteDevice } from './devices.api';
export const useRegisterDeviceMutation = () => {
    return useMutation({
        mutationFn: registerDevice
    });
};
export const useDeleteDeviceMutation = () => {
    return useMutation({
        mutationFn: deleteDevice
    });
};
//# sourceMappingURL=devices.query.js.map